/*
 * AAPL WebSite for guest & member
 * @author Yooseng <hi@xoe.io>
 * @create data 2024-08-11
 * @copyright Copyright (c) 2019, Funqum(Beijing) Ltd.
 */
import Vue from 'vue';
import App from '@/App.vue';

import router from '@/router';
import store from '@/store';

import global from '@/common/global';
import vuetify from '@/common/vuetify';
import ApiService from '@/common/http';

import '@/components';
import '@/common/filters';
import '@/common/plugins';
import '@/common/drag'
import '@/router/auth';
import '@/registerServiceWorker'
import { writeLog } from '@/common/operationlog'

import { Dialog } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(Dialog);

// import VueCoreVideoPlayer from 'vue-core-video-player'
// Vue.use(VueCoreVideoPlayer);
// Vue.use(VueCoreVideoPlayer, {lang: 'zh-CN'});

import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'
Vue.use(VuePlyr, {
  plyr: {
    i18n: {
      speed: '速度',
      normal: '正常',
    },
  }
})

Vue.config.productionTip = false;
Vue.prototype.ossURL = process.env.VUE_APP_OSS_URL || 'localhost:8081';
Vue.prototype.Global = global;

ApiService.init();

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app');

//用户埋点：点击事件记录
Vue.directive('log', {
  bind: (el, binding) => {
    el.addEventListener('click', () => {
      writeLog('click', binding.value, null, null, el.getAttribute('log-param'))
    }, false)
  }
})
